module.exports = __webpack_public_path__ + "static/media/SM-MT-TRIAL1.5516c2ca.mp3";